import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./Login.scss";

// prop types
import userPropTypes from "../../propTypes/userPropTypes";

// actions
import * as userActions from "../../actions/userActions";
import * as oAuthActions from "../../actions/oAuthActions";
import * as verifyActions from "../../actions/verifyActions";

//components
import GoogleButton from "../../coraWebComponents/buttons/GoogleButton";
import Login from "../../coraWebComponents/views/login/FullscreenLogin";
import { afterLoginHandle, buildUrl } from "../../coraWebComponents/utils/helper";
import withRouter from "../../coraWebComponents/utils/withRouter";
import { showMsg } from '../../coraWebComponents/utils/logger';

// routes
import Routes from "../../constants/Routes";

const googleRedirectURI = `${window.config.redirectURI}?provider=1`;

const LoginWrapper = (props) => {
  const signInOAuthHandle = async (loginProps, code, provider) => {
    await props.signInOAuth(code, googleRedirectURI, provider);

    const { user } = props;
    if (user !== null) afterLoginHandle(loginProps, user.Uzivatel.N_UZ);
  };

  const verifyGUID = async (guid) => {
    await props.verifyGUID(guid);
    props.showMsg("Mail je úspešne overený. Môžte sa prihlásiť.");
    await new Promise(resolve => setTimeout(resolve, 8000));
  };

  return (
    <Login
      user={props.user}
      isLoading={props.isLoading}
      rememberDisabled={false}
      logoUrl={buildUrl('assets/sitelLogo.svg')}
      backgroundUrl={buildUrl('assets/background_login.jpg')}
      appFullName={"Zákaznícky informačný portál"}
      userNameLabel="Prihlasovacie meno / Email"
      passwordLabel="Heslo"
      oAuthLogin={signInOAuthHandle}
      verifyGUID={verifyGUID}
      afterSignIn={props.signIn}
      afterLoginlocation={{ from: { pathname: Routes.HOME } }}
      showMsg={props.showMsg}
      showForgotPassword={true}
      routeForgotPassword={Routes.FORGOT_PASSWORD}
      loginFooter={<div className="cennik">
        Vážený používateľ ZIS portálu spoločnosti SITEL s.r.o.!<br />
        Všetky služby spojené s vyjadrením a vytýčením inžinierskych sietí EKS v správe a majetku
        spoločnosti SITEL s.r.o. sú spoplatené.<br />
        Aktuálny cenník našich služieb nájdete na webovej stránke <a href="https://www.sitel.sk/sk/cennik/">www.sitel.sk/sk/cennik</a>.
      </div>}
    >
      {false && <div className="k-form-field">
        <div className="line">
          <span className="service-label">alebo</span>
        </div>
        <div className="row m-0">
          <GoogleButton
            redirectURI={googleRedirectURI}
            state="logging"
            primary={false}
          />
        </div>
      </div>}
      <div />
      <div className="k-form-field">
        <div className="footerContainerLogin">Ste tu nový?&nbsp;&nbsp;
          <a className="registration" href={`#${Routes.REGISTRACIA}`}>
            Registrovať sa
          </a>
        </div>
      </div>
    </Login>
  );
}

const mapStateToProps = (state) => ({
  isLoading: state.user.isLoading || state.oAuthUser.isLoading,
  user: state.user.data,
});

const mapDispatchToProps = (dispatch) => ({
  signIn: (res) => dispatch(userActions.afterSignIn(res)),
  signInOAuth: (code, redirect_uri, provider) => dispatch(oAuthActions.loginOAuth(code, redirect_uri, provider)),
  verifyGUID: (guid) => dispatch(verifyActions.GUID(guid)),  
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
});

LoginWrapper.propTypes = {
  isLoading: PropTypes.bool,
  signInOAuth: PropTypes.func,
  signIn: PropTypes.func,
  user: userPropTypes.user,
  verifyGUID: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginWrapper)
);
